/**
 * Importes escritos a mano. Los campos de importe son de texto con teclado
 * decimal (inputMode="decimal"): en un iPhone en español ese teclado trae coma,
 * y un campo type="number" de Safari no la acepta (se queda vacío).
 */

/** «12,5» o «12.5» → 12.5. Como parseFloat: NaN si no es un número. */
export const aNumero = (texto: string) => parseFloat(texto.replace(',', '.'));

/** Para el atributo pattern: un importe de 0 o más, con coma o punto. */
export const PATRON_IMPORTE = '[0-9]*[.,]?[0-9]*';

/** Igual, pero mayor que cero (al menos una cifra que no sea 0). */
export const PATRON_IMPORTE_POSITIVO = '(?=.*[1-9])[0-9]*[.,]?[0-9]*';

export const AVISO_IMPORTE = 'Escribe un importe, por ejemplo 12,50';

/**
 * Importe en euros al estilo español: «1.234,50 €». Con `signo`, los
 * positivos llevan «+» (para diferencias). El punto de miles se pone siempre,
 * también en 4 cifras: Intl en es-ES no lo pone en «1234», y así se lee igual
 * en toda la app.
 */
export function formatoEuros(valor: number, signo = false): string {
  const redondeado = Math.round(valor * 100) / 100;
  const negativo = redondeado < 0;
  const [enteros, decimales] = Math.abs(redondeado).toFixed(2).split('.');
  const conMiles = enteros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const prefijo = negativo ? '-' : signo && redondeado > 0 ? '+' : '';
  return `${prefijo}${conMiles},${decimales} €`;
}

/** Porcentaje sin decimales al estilo español: «23 %». */
export const formatoPorcentaje = (valor: number) => `${Math.round(valor)} %`;
